import { StyleProvider } from '@ant-design/cssinjs';
import { App as AntApp, ConfigProvider } from 'antd';
import ptBR from 'antd/es/locale/pt_BR.js';
import { useTheme } from '@/features/layout/hooks/useTheme';
import { Router } from '@/router/Router';
import { useAppSistema } from './useAppSistema';
import { useAppVersion } from './useAppVersion';

export function App() {
    const themeConfig = useTheme();

    useAppSistema();
    useAppVersion();

    return (
        <StyleProvider layer={true}>
            <ConfigProvider locale={ptBR} theme={themeConfig}>
                <AntApp>
                    <Router />
                </AntApp>
            </ConfigProvider>
        </StyleProvider>
    );
}
